var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMasterCard = function SvgMasterCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 46 29"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E15D29",
    d: "M16.818 25.08h12.169V3.341H16.818V25.08z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2232C",
    d: "M17.592 14.21c0-4.41 2.077-8.337 5.311-10.869A13.896 13.896 0 0 0 14.31.385C6.63.385.403 6.575.403 14.211c0 7.635 6.226 13.825 13.906 13.825 3.244 0 6.229-1.104 8.594-2.956-3.234-2.532-5.311-6.46-5.311-10.87z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EC972D",
    d: "M44.97 22.777v-.536h-.142l-.162.369-.161-.369h-.142v.536h.1v-.405l.151.35h.104l.151-.35v.405h.1zm-.893 0v-.445h.18v-.09h-.46v.09h.18v.445h.1zm1.326-8.567c0 7.636-6.225 13.825-13.905 13.825a13.891 13.891 0 0 1-8.594-2.956c3.235-2.53 5.311-6.459 5.311-10.87 0-4.41-2.076-8.337-5.31-10.869A13.897 13.897 0 0 1 31.497.385c7.68 0 13.905 6.19 13.905 13.825z"
  })));
};
export { SvgMasterCard as ReactComponent };
export default __webpack_public_path__ + "assets/master-card.svg";